export default __webpack_public_path__ + "KaTeX_Typewriter-Regular.b1d1af1a936d0174df3012bd14c56561.ttf";